import {
  characterCardsForPanel,
  type ComicCharacterCard,
  migrateCreativeToCharacterCards,
} from '../comicCharacters'
import type { ComicProjectCreative } from '../comicDomainTypes'
import type { ComicPanel } from '../comicTypes'

export function allCharacterCards(creative: ComicProjectCreative): ComicCharacterCard[] {
  return creative.characters?.length
    ? creative.characters
    : migrateCreativeToCharacterCards(creative)
}

/** 本页各格出场角色并集，按格序首次出现排序 */
export function collectPageCast(
  creative: ComicProjectCreative,
  panels: ComicPanel[],
): ComicCharacterCard[] {
  const seen = new Set<string>()
  const out: ComicCharacterCard[] = []
  for (const panel of panels) {
    if (!panel) continue
    for (const card of characterCardsForPanel(creative, panel)) {
      if (seen.has(card.id)) continue
      seen.add(card.id)
      out.push(card)
    }
  }
  return out
}

/** 注入 prompt 的短外貌（有参考图时截更短，无文案则返回空） */
export function shortCharacterAppearance(card: ComicCharacterCard, hasRef: boolean): string {
  const raw = card.appearance.trim()
  if (!raw) return ''
  const first = raw.split(/[；;]/)[0]?.trim() ?? raw
  const cap = hasRef ? 48 : 96
  return first.length > cap ? `${first.slice(0, cap)}…` : first
}
